/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Psod_Contact_BeforeInputs */

const fr_psod_contact_before = /** @type {(inputs: Psod_Contact_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enfin, un contact est possible à l'adresse `)
};

const en_psod_contact_before = /** @type {(inputs: Psod_Contact_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finally, you can contact me at `)
};

/**
* | output |
* | --- |
* | "Finally, you can contact me at" |
*
* @param {Psod_Contact_BeforeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const psod_contact_before = /** @type {((inputs?: Psod_Contact_BeforeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Psod_Contact_BeforeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_psod_contact_before(inputs)
	return en_psod_contact_before(inputs)
});